.root {
    display: grid;
    grid-template-columns: subgrid;
    align-items: center;
    padding: 15px;

    @media (width > 768px) {
        padding: 20px;
    }

    appearance: none;
    color: inherit;
    font: inherit;

    --category-hsl: var(--inline-category-hsl);

    background: hsl(var(--category-hsl) / 20%);
    border: 1px solid hsl(var(--category-hsl) / 40%);

    cursor: pointer;

    &:hover,
    &:focus {
        background: hsl(var(--category-hsl) / 25%);
    }

    &:active {
        background: hsl(var(--category-hsl) / 30%);
    }

    &:disabled {
        pointer-events: none;
        filter: saturate(50%);
        color: hsl(0deg 0% 100% / 70%);
        background-color: hsl(var(--category-hsl) / 5%);
        border-color: hsl(var(--category-hsl) / 20%);
    }
}

.description {
    display: flex;
    flex-direction: column;
    align-items: start;
    text-align: start;
}

.category {
    text-transform: uppercase;
    font-weight: 500;
    font-size: .8em;
    color: hsl(var(--category-hsl));
}

.valueContainer {
    display: flex;
    flex-direction: column;
    align-items: end;
    text-align: end;

    font-size: 0.8em;

    @media (width > 768px) {
        font-size: 1em;
    }
}

.valueCurrent {
    opacity: 0.8;
    font-size: 0.8em;
}
